import { FC, PropsWithChildren } from 'react';
import { NavLink } from 'react-router';
import { Text } from '@/components/base';
import { toClassNames } from '@/utils';

type ItemProps = PropsWithChildren<{
  to: string;
  label: string;
}>;

export const BottomNavbarStickyItem: FC<ItemProps> = ({ to, label, children }) => (
  <NavLink className="flex h-bottom-navbar-mobile w-1/4 flex-col items-center justify-center gap-1 py-2" to={to}>
    {({ isActive }) => (
      <>
        <div
          className={toClassNames(
            'flex items-center justify-center',
            isActive ? 'text-revamp-gray-700' : 'text-revamp-gray-400'
          )}
        >
          {children}
        </div>
        <Text
          variant="caption"
          version="revamp-v1"
          className={toClassNames(
            'w-full overflow-hidden text-ellipsis whitespace-nowrap text-center',
            isActive ? 'text-revamp-gray-900' : 'text-revamp-gray-500'
          )}
        >
          {label}
        </Text>
      </>
    )}
  </NavLink>
);
